// Urgency = (ช่องว่างที่ต้องปิดก่อนของถึง) × เวลา — ห้ามเรียงด้วย ETA อย่างเดียว
// สูตรจาก docs/handoff/03_screen_console.md (หัวใจของ queue jump)

const BLOCKING_NEEDED_BY = ['before_ship', 'before_pickup', 'before_clear'];
// done = ปิดงานแล้ว — ต้องอยู่ท้ายสุดเสมอ ไม่ใช่ของเร่ง (ไม่งั้นตู้เก่าที่ปิดแล้วเด้งขึ้นบนเป็นสีแดง)
const RANK = { urgent: 2, watch: 1, ok: 0, done: -1 };

export function daysUntil(dateStr) {
  if (!dateStr) return Infinity;
  const d = new Date(dateStr); d.setHours(0, 0, 0, 0);
  const now = new Date(); now.setHours(0, 0, 0, 0);
  return Math.round((d - now) / 86400000);
}

// requirements = แถว document_requirement ของ shipment นั้น
export function computeUrgency(shipment, requirements) {
  const blockingGaps = requirements.filter(r =>
    r.required &&
    ['missing', 'flagged'].includes(r.status) &&
    BLOCKING_NEEDED_BY.includes(r.needed_by)
  ).length;
  const flaggedCount = requirements.filter(r => r.status === 'flagged').length;

  const clock = Math.min(daysUntil(shipment.eta), daysUntil(shipment.free_time_ends));

  const urgency =
    (blockingGaps > 0 && clock <= 5) ? 'urgent'
    : (clock <= 7 || flaggedCount > 0) ? 'watch'
    : 'ok';

  return { urgency, clock, blockingGaps, flaggedCount };
}

// เรียง: urgent ก่อน → แล้วนาฬิกาที่บีบสุดก่อน
export function sortByUrgency(list) {
  return [...list].sort((a, b) =>
    (RANK[b.urgency] - RANK[a.urgency]) || (a.clock - b.clock));
}
